module.exports = __webpack_public_path__ + "static/img/tokenpocket@3x.7163a05.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tokenpocket@3x.jpeg
// module id = K8a9
// module chunks = 7